<cm-canvas-base #canvasBase navigationMode="Panning" [imageData]="$imageData()" [transparencyGrid]="true">
    <ng-content></ng-content>
</cm-canvas-base>
